<template>
  <Dialog v-model="visible" variant="panel" :title="title">
    <div class="record-dialog">
      <RecordTable
        :class="isPurchase ? 'record-table--purchase' : 'record-table--milestone'"
        :headers="headers"
        :rows="rows"
        :empty-text="$t('novShopping.common.empty')"
      />
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../Dialog/index.vue'
import RecordTable from './components/RecordTable/index.vue'
import { parsePropSnapshot } from '../../utils/prop'
import { formatRecordTime } from '../../utils/time'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  // purchase-兑换记录 | milestone-领取记录
  type: {
    type: String,
    default: 'purchase',
  },
  list: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])

const { t } = useI18n()

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const isPurchase = computed(() => props.type === 'purchase')

const title = computed(() => (isPurchase.value ? t('novShopping.goods.history') : t('novShopping.milestone.history')))

// 双端共用记录数据和表头，由各自的样式控制列宽。
const headers = computed(() => ({
  first: isPurchase.value ? t('novShopping.goods.spent') : t('novShopping.milestone.header'),
  second: isPurchase.value ? t('novShopping.goods.details') : t('novShopping.milestone.rewardDetails'),
  time: isPurchase.value ? t('novShopping.goods.time') : t('novShopping.milestone.claimTime'),
}))

// 统一成展示型数据，表格组件只负责排版。
const rows = computed(() => (props.list || []).map((item, index) => ({
  key: `${item.id || index}`,
  first: isPurchase.value ? `-${item.costSnapshot}` : item.targetSpent,
  props: parsePropSnapshot(item.propSnapshot),
  time: formatRecordTime(item.createTime || item.receiveTime),
})))
</script>

<style lang="less" scoped>
.record-dialog {
  box-sizing: border-box;
  height: 100%;
  min-height: 0;
}
</style>
